module.exports = __webpack_public_path__ + "static/media/allthemoney.4927c8bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/allthemoney.jpg
// module id = 46
// module chunks = 0